import { render, staticRenderFns } from "./modalRecebimentoIncidenciaManual.vue?vue&type=template&id=b115c19e"
import script from "./modalRecebimentoIncidenciaManual.vue?vue&type=script&lang=js"
export * from "./modalRecebimentoIncidenciaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports